module.exports = __webpack_public_path__ + "static/media/kite375.6d407380.png";